import { render } from "./Home2026.vue?vue&type=template&id=aa0ce1fc"
import script from "./Home2026.js?vue&type=script&lang=js"
export * from "./Home2026.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__